var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDutch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1766_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 9.37935H-0.000427246V4.55175C-0.000427246 4.32324 0.184869 4.13794 0.413384 4.13794H23.5858C23.8143 4.13794 23.9996 4.32324 23.9996 4.55175L23.9995 9.37935Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9322 14.688V19.4478C23.9322 19.6391 23.7768 19.7944 23.5855 19.7944H0.413635C0.222338 19.7944 0.0669556 19.6391 0.0669556 19.4478V14.688H23.9322Z",
    stroke: "white",
    strokeWidth: 0.134776
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 9.37915H-0.000427246V14.6202H23.9995V9.37915Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1766_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDutch);
export default __webpack_public_path__ + "static/media/dutch.bfbf72093cab017d8b23f2d4bb6a9797.svg";
export { ForwardRef as ReactComponent };